import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
import {
  Flex, Pagination, PaginationProps, Row, Select, Spin,
} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useResizeWidthWindow } from '../hook/useResizeWidthWindow';
import dataOther from '../../awards_others_data.json';
import { OtherCardItemType } from '../../../../common/types';
import { defaultPageSize, pageSizeOptions } from '../../consts';
import { OtherCardItem } from '../card/OtherCardItem';
import { fetchListOthers } from '../../store/slices/awmacSlice';
import { AppDispatch, RootState } from '../../store';

interface TabProjectAwardsProps {
}

// const FlexStyled = styled(Flex)`
//   align-items: stretch;
// `;

const DivFilterStyled = styled.div`
  margin: 20px 0px;
  align-items: stretch;

  @media (max-width: 768px) {
    margin: 10px 0px;
  }
`;

const FlexFilterStyled = styled(Flex)`
  padding: 20px;
  border: 1px solid rgba(115, 115, 115, 0.2);
  background-color: #FAFAFA;
  border-radius: 4px;
`;

const FlexPaginatorStyled = styled(Flex)`
  margin-top: 20px;

  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;

export const TabOtherAwards: React.FC<TabProjectAwardsProps> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedYears, setSelectedYears] = useState<number[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string[]>([]);
  const [spin, setSpin] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [newPageSize, setNewPageSize] = useState(defaultPageSize);
  const startIndex = (currentPage - 1) * newPageSize;
  const endIndex = startIndex + newPageSize;
  const listOther = useSelector((state: RootState) => state.awmac.awmacOtherList);

  const filteredAwards = useMemo(() => (Object.values(dataOther) as OtherCardItemType[]).filter((award) => {
    const matchYear = selectedYears.length === 0 || selectedYears.includes(award.year);
    const matchCategory = selectedCategory.length === 0 || selectedCategory.includes(award.award);

    return matchYear && matchCategory;
  }), [selectedYears, selectedCategory]);

  const paginatedData = filteredAwards.slice(startIndex, endIndex);

  useEffect(() => {
    (async () => {
      try {
        dispatch(fetchListOthers());
      } catch (e) {
        console.log(e);
      }
    })();
  }, [dispatch]);

  useEffect(() => {
  }, []);

  const selectYears = Array.from(new Set(Object.values(dataOther).map((item) => item.year))).sort((a, b) => b - a);

  const optionsYears = selectYears.map((category) => ({
    label: category,
    value: category,
  }));

  const selectCategory = Array.from(
    new Set(Object.values(dataOther).map((item) => item.award)),
  ).filter(Boolean);

  const optionsCategory = selectCategory.map((category) => ({
    label: category,
    value: category,
  }));

  const handleYearChange = (value: number[]) => {
    setSpin(true);
    setTimeout(() => setSpin(false), 500);
    setSelectedYears(value);
  };

  const handleCategoryChange = (value: string[]) => {
    setSpin(true);
    setTimeout(() => setSpin(false), 500);
    setSelectedCategory(value);
  };

  const onShowSizeChange: PaginationProps['onShowSizeChange'] = (current, pageSize) => {
    setCurrentPage(current);
    setNewPageSize(pageSize);
  };

  const showTotal: PaginationProps['showTotal'] = (total) => `Total ${total} projects`;

  return (<div style={{ width: '100%' }}>
          <Helmet>
              <title>OTHER AWARDS</title>
              <meta
                  name="description"
                  content="AWMAC - Architectural Woodwork Manufacturers Association of Canada AWARDS"
              />
              <link rel="canonical" href='https://awmacbc.com/other'/>
          </Helmet>
          <DivFilterStyled>
              <FlexFilterStyled vertical gap={10}>
                  <Select
                      mode="tags"
                      size={'middle'}
                      placeholder="Select a year"
                      defaultValue={[]}
                      onChange={handleYearChange}
                      style={{ width: '100%' }}
                      options={optionsYears}
                  />
                  <Select<string[]>
                      mode="tags"
                      size={'middle'}
                      placeholder="Select a category"
                      defaultValue={[]}
                      onChange={handleCategoryChange}
                      style={{ width: '100%' }}
                      options={optionsCategory}
                  />
              </FlexFilterStyled>
          </DivFilterStyled>
          <Spin spinning={spin} style={{ minHeight: 400 }} indicator={<LoadingOutlined style={{ fontSize: 100 }}/>}>
              {/* <FlexStyled justify={'flex-start'} align={'center'} wrap={'wrap'} gap={20}> */}
              <div>
                  <Row gutter={[24, 24]}>
                          {
                              paginatedData.map((otherAward) => {
                                const imgPath = `${otherAward.id}/${listOther[otherAward.id]}`;

                                const images = `${process.env.REACT_APP_S3_STORAGE_URL_OTHER}/${process.env.REACT_APP_BUCKET_OTHER}/${imgPath}`;

                                if (!images || images.length === 0 || !listOther[otherAward.id]) {
                                  return null;
                                }

                                return (
                                  <OtherCardItem
                                      key={otherAward.id}
                                      dataCard={otherAward}
                                      images={images}
                                  />
                                );
                              })
                          }
                  </Row>
              </div>
              {/* </FlexStyled> */}
              <FlexPaginatorStyled justify={'center'}>
                  <Pagination
                      showSizeChanger
                      onChange={onShowSizeChange}
                      onShowSizeChange={onShowSizeChange}
                      defaultCurrent={1}
                      total={filteredAwards.length}
                      showTotal={showTotal}
                      pageSizeOptions={pageSizeOptions}
                      defaultPageSize={defaultPageSize}
                      size={useResizeWidthWindow() < 700 ? 'small' : 'default'}
                  />
              </FlexPaginatorStyled>
          </Spin>
        </div>
  );
};
